import { __awaiter, __generator } from "tslib";
import { queryCache } from '@office-start/data-fetching';
import { fetchIdentity } from '@office-start/identity-service';
import { getWebStorageKey } from '../util/getWebStorageKey';
import { executeWebStorageGetUserItem } from './executeWebStorageGetUserItem';
export function fetchWebStorageGetUserItem(storageKey) {
    return __awaiter(this, void 0, void 0, function () {
        var identity, queryKey;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetchIdentity()];
                case 1:
                    identity = _a.sent();
                    queryKey = getWebStorageKey(storageKey);
                    return [4 /*yield*/, queryCache.fetchQuery(queryKey, function () { return executeWebStorageGetUserItem({ identity: identity, storageKey: storageKey }); }, {
                            cacheTime: Infinity,
                            staleTime: Infinity,
                            enabled: !!identity,
                        })];
                case 2: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
//# sourceMappingURL=fetchWebStorageGetUserItem.js.map